module.exports = __webpack_public_path__ + "img/micromall_banner.b59ac0cb.png";